import { trustUrls } from '../utils/urlResolver';
import axios from '.';

export const getTrustTableData = (data) => {
  const {
    endDate,
    limit,
    needType,
    page,
    startDate,
    trustType: dataTrustType,
    contractType,
    timezone,
    search,
  } = data || {};
  let trustUrl = `${trustUrls.trust_report.url}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&needType=${needType}&trustType=${dataTrustType}&contractType=${contractType}&timezone=${timezone}`;
  if (search) trustUrl += `&search=${search}`;
  return axios({
    method: 'get',
    url: trustUrl,
  });
};

export const fetchTrustAccountData = (data) => {
  const { needType, trustType: dataTrustType, contractType, search } = data || {};
  return axios({
    method: 'get',
    url: `${trustUrls.trust_report.fetchdata}?needType=${needType}&trustType=${dataTrustType}&contractType=${contractType}&search=${search}`,
  });
};

export const getTrustAccountDetail = ({ id }) => {
  return axios({
    method: 'get',
    url: `${trustUrls.trust_report.trustAccount}/${id}?viewType=undefined&lastEditedApplication=Oneportal`,
  });
};
export const getProjectionData = ({ id, contractType = 0 }) => {
  return axios({
    method: 'get',
    url: `${trustUrls.trust_report.getprojectiondata}?id=${id}&contractType=${contractType}`,
  });
};
export const getAgrimentData = ({ id }) => {
  return axios({
    method: 'get',
    url: `${trustUrls.trust_report.agreement}/${id}`,
  });
};
